var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseNoborderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13374 25.65H4.75873C3.64026 25.65 2.73373 24.7176 2.73373 23.5672V3.43286C2.73373 2.28243 3.64026 1.35001 4.75873 1.35001H8.13374C9.25221 1.35001 10.1587 2.28243 10.1587 3.43286V23.5672C10.1587 24.7176 9.25221 25.65 8.13374 25.65Z",
    stroke: "#131313",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3155 25.65H18.9405C17.822 25.65 16.9155 24.7176 16.9155 23.5672V3.43286C16.9155 2.28243 17.822 1.35001 18.9405 1.35001H22.3155C23.434 1.35001 24.3405 2.28243 24.3405 3.43286V23.5672C24.3405 24.7176 23.434 25.65 22.3155 25.65Z",
    stroke: "#131313",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseNoborderIcon);
export default __webpack_public_path__ + "static/media/pause-noborder-icon.faad2861b6cec41de89eeb2e0e0e6a44.svg";
export { ForwardRef as ReactComponent };